import React from 'react';
import {observer, inject} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Button, FormGroup, ControlLabel, ButtonToolbar} from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import Select from 'react-select-plus'
import 'react-select-plus/dist/react-select-plus.css';


@injectIntl @inject('rootStore', 'valuePropositionsStore', 'authorizationsStore') @observer
export default class ValuePropositionToolbar extends React.Component {

    render() {
        const {intl, feedbackChain, valuePropositionsStore, authorizationsStore} = this.props;
        const selectedValueProposition = valuePropositionsStore.valuePropositionsSelectOptions.
            find( (opt) => 
                opt.value.id == feedbackChain.valuePropositionId
            );
        return(
            <div className="value-proposition-toolbar">
                <span className='bold'><i className='fa fa-gift'/>&nbsp;{intl.formatMessage({id: 'value_proposition_select_label'})}</span>
                <FormGroup
                    controlId="value-proposition-form"
                >
                    <Select options={valuePropositionsStore.valuePropositionsSelectOptions}
                            value={selectedValueProposition}
                            onChange={this.handleValuePropositionSelect}
                            placeholder={intl.formatMessage({id: 'value_proposition_select_placeholder'})}
                            clearable={false}
                             disabled={!authorizationsStore.canCreateTask()}
                    /><br/>
                </FormGroup>
            </div>
        );
    }

    handleValuePropositionSelect = (selected) => {
        this.props.feedbackChain.setValuePropositionId(selected.value.id);
    }
}